module.exports = __webpack_public_path__ + "static/media/english_icon.1f619dfd.svg";